import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@utils/auth';
import { Header } from '../../components/shared/header';

function PrivateLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header - Full Width */}
      <Header />

      {/* Content Area Below Header - Full Width */}
      <div className="h-[calc(100vh-65px)] w-screen">
        {/* Main Content - 100% width */}
        <main className="h-full w-full overflow-y-auto">
          <div className="h-full w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/(private)')({
  beforeLoad: () => {
    // Prevenir loops de redirecionamento
    const redirectKey = 'fila_redirect_in_progress';
    const lastRedirect = sessionStorage.getItem(redirectKey);
    const now = Date.now();

    // Se há redirecionamento em progresso, aguardar um pouco antes de verificar
    if (lastRedirect && (now - parseInt(lastRedirect)) < 1000) {
      console.log('🔄 Redirecionamento recente detectado, verificando autenticação...');
      // Ainda verificar autenticação, mas com mais cuidado
      if (!isAuthenticated()) {
        // Limpar flag e redirecionar
        sessionStorage.removeItem(redirectKey);
        throw redirect({ to: '/login' });
      }
      return; // Permitir acesso se está autenticado
    }

    if (!isAuthenticated()) {
      // Marcar redirecionamento para prevenir loops
      sessionStorage.setItem(redirectKey, now.toString());
      throw redirect({ to: '/login' });
    }
  },
  component: PrivateLayout,
});
